import get from 'lodash/get'
import {createSelector} from "reselect";

export const isSearching = (state) => get(state, ['vegetation', 'search', 'searching'])
export const getSearchParams = (state) => get(state, ['vegetation', 'search', 'params'])
export const getSearchResults = (state) => get(state, ['vegetation', 'search', 'results'])

export const getSearchPage = createSelector(getSearchResults, (results) => get(results, ['page']));
export const getSearchLimit = createSelector(getSearchResults, (results) => get(results, ['limit']));
export const getSearchOrder = createSelector(getSearchResults, (results) => get(results, ['order']));
export const getSearchTotal = createSelector(getSearchResults, (results) => get(results, ['total']));
export const getSearchItems = createSelector(getSearchResults, (results) => get(results, ['items']));



// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/search.js